import { TextareaProps } from "./Textarea.type";

const INPUT_COLOR_ERROR = "red";
const INPUT_COLOR = "#D0D0D0";

export default function Textarea({
  fieldName,
  label,
  register,
  required,
  error,
  onChange,
  styles,
  maxlength,
  rows,
  readOnly,
}: TextareaProps) {
  return (
    <>
      <textarea
        disabled={readOnly}
        className={styles}
        {...register(fieldName, {
          required,
        })}
        style={{
          borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
        }}
        onChange={onChange}
        placeholder={label}
        maxLength={maxlength}
        rows={rows}
      ></textarea>
      {/* ERRORS MESSAGE */}
      {error?.message && (
        <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
      )}
      {error?.type === "required" && (
        <span style={{ color: INPUT_COLOR_ERROR }}>Campo Obligatorio*</span>
      )}
    </>
  );
}
